import React from 'react';

// Small badge that makes it easy to see whether a member has a subscription:
//   green with the plan name  = has a live subscription (linked plan)
//   amber "No subscription"   = none yet
//   a dash                    = admins, who are not expected to have one
const SubscriptionStatusBadge = ({ user }) => {
    if (user.isAdmin) {
        return <span className="text-xs text-emerald-600/50" title="Admins do not need a subscription">-</span>;
    }

    if (user.hasSubscription) {
        return (
            <span
                className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-emerald-900/30 text-emerald-300 border border-emerald-700/40"
                title="Has a live subscription"
                data-testid="subscription-badge"
            >
                {user.subscriptionName || 'Subscribed'}
            </span>
        );
    }

    return (
        <span
            className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-900/30 text-amber-300 border border-amber-700/40"
            title="No live subscription yet"
            data-testid="subscription-badge"
        >
            No subscription
        </span>
    );
};

export default SubscriptionStatusBadge;
